import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureStateIndicator } from '../../../../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { IconCaret } from '../../../../vtex-apps/icons/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { DispositionLayout } from '../../../../vtex-apps/peer/DispositionLayout/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { Video } from '../../../../vtex-apps/Video/default';

// this template needs to have a templateId of 6, this is an exception, not a rule
const InstitutionalGroup = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		templateId: 6,
		variables,
		props: FlexLayoutRow({
			mzTitle: 'EG | Bloco institucional',
			blockClass: ['flex-row-container__inst-group-6'],
			marginTop: { desktop: 8, tablet: 8, phone: 8 },
		}).props,
		childrenComponents: [
			FlexLayoutCol(
				{
					mzTitle: 'EG | Menu',
					blockClass: 'menu-col__inst-group-6',
					width: { desktop: '20%', mobile: '100%' },
				},
				[
					DisclosureLayout({ animated: true, initialVisibility: 'visible' }, [
						DisclosureTrigger({ blockClass: 'menu-trigger__inst-group-6', as: 'div' }, [
							RichText({
								mzTitle: 'EG | Título Menu',
								blockClass: 'menu-header__inst-group-6',
								text: '### Menu Institucional',
							}),
							DisclosureStateIndicator({
								Show: IconCaret({
									orientation: 'up',
									activeClassName: 'disclosure-trigger__inst-group-6',
									mutedClassName: 'disclosure-trigger__inst-group-6',
									handle:
										'caretIcon--disclosure-trigger__inst-group-6 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger__inst-group-6',
								}),
								Hide: IconCaret({
									orientation: 'down',
									activeClassName: 'disclosure-trigger__inst-group-6',
									mutedClassName: 'disclosure-trigger__inst-group-6',
									handle:
										'caretIcon--disclosure-trigger__inst-group-6 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger__inst-group-6',
								}),
							}),
						]),
						DisclosureContent({ blockClass: 'disclosure-content__inst-group-6' }, [
							Menu({
								blockClass: 'menu__inst-group-6',
								orientation: 'vertical',
								items: [
									MenuItem({
										blockClass: 'menu-item__inst-group-6',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Sobre a Marca', text: 'Sobre a Marca' },
									}).props,
									MenuItem({
										blockClass: 'menu-item__inst-group-6',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Trabalhe conosco',
											text: 'Trabalhe conosco',
										},
									}).props,
									MenuItem({
										blockClass: 'menu-item__inst-group-6',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Dicas e novidades',
											text: 'Dicas e novidades',
										},
									}).props,
									MenuItem({
										blockClass: 'menu-item__inst-group-6',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Nossas lojas', text: 'Nossas lojas' },
									}).props,
								],
							}),
						]),
					]),
				],
			),
			FlexLayoutCol(
				{
					mzTitle: 'EG | Conteúdo',
					blockClass: 'inst-6__conteudo',
					width: { desktop: '80%', mobile: '100%' },
					marginLeft: { desktop: 9, tablet: 0, phone: 0 },
				},
				[
					DispositionLayout(
						{
							mzTitle: 'EG | Blocos',
							disposition: [
								{
									show: true,
									order: 1,
								},
								{
									show: true,
									order: 2,
								},
								{
									show: true,
									order: 3,
								},
								{
									show: true,
									order: 4,
								},
								{
									show: true,
									order: 5,
								},
							],
						},
						[
							RichText({
								mzTitle: 'EG | Conteúdo 1',
								blockClass: 'body__inst-group-6',
								text: '![Teste](https://fakeimg.pl/1920x560/) \n\n ## Título institucional EG | H1 \n Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla consequat ac turpis nec congue. Ut efficitur blandit tempus. Mauris quis tellus facilisis, faucibus dui a, condimentum tortor. Nunc dignissim, augue nec ultrices pulvinar, nunc turpis vulputate ipsum, id convallis dolor mi a eros. In maximus ligula eget nisl dignissim, id sagittis metus accumsan. Fusce sed ex a nisi vehicula dignissim. Donec et faucibus nisl, quis dapibus urna. Nulla gravida ornare lectus a varius. Cras dignissim nec ante et ullamcorper. Proin varius sem ac lectus dictum egestas. Suspendisse semper tortor eu ante aliquet, sed lacinia risus dignissim. Aenean sagittis finibus elit accumsan vestibulum. Phasellus fermentum porta arcu eu ultricies.\n\n Praesent efficitur sollicitudin posuere. Curabitur sit amet luctus massa. Donec viverra nisi congue purus vestibulum, vel rhoncus eros lobortis. Mauris pellentesque aliquam nunc, mollis rutrum tellus consectetur in. Curabitur rutrum rutrum ex et blandit. Pellentesque odio enim, placerat vitae congue eget, volutpat lobortis nisi. Donec massa orci, euismod ut suscipit nec, cursus sed quam. Suspendisse iaculis lorem id nisi aliquam, sit amet maximus est tristique.\n\n Curabitur ut orci nisi. Praesent lectus lectus, maximus sed metus at, lobortis efficitur velit. In a nunc id magna accumsan ullamcorper vitae scelerisque nisi. Duis sollicitudin massa sed pharetra vehicula. Aenean metus justo, rutrum vel tincidunt tempor, viverra nec purus. Etiam et pharetra mauris. Donec sodales gravida tortor, in tristique felis finibus ut. Nunc egestas sapien nec turpis sollicitudin, ut tristique magna accumsan. Integer posuere gravida diam. Curabitur ut sodales sapien.',
							}),
							FlexLayoutRow(
								{
									blockClass: 'flex-col__brand-group-1',
									width: '100%',
								},
								[
									StoreImageList(
										{
											mzTitle: 'EG | Slider',
											preload: true,
											height: 400,
											images,
										},
										[
											SliderLayout({
												label: 'slider',
												itemsPerPage: {
													desktop: 1,
													tablet: 1,
													phone: 1,
												},
												blockClass: 'slider__brand-group-1',
												fullWidth: true,
											}),
										],
									),
								],
							),
							RichText({
								mzTitle: 'EG | Conteúdo 2',
								blockClass: 'body__inst-group-6',
								text: '## Título institucional EG | H1 \n Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla consequat ac turpis nec congue. Ut efficitur blandit tempus. Mauris quis tellus facilisis, faucibus dui a, condimentum tortor. Nunc dignissim, augue nec ultrices pulvinar, nunc turpis vulputate ipsum, id convallis dolor mi a eros. In maximus ligula eget nisl dignissim, id sagittis metus accumsan. Fusce sed ex a nisi vehicula dignissim. Donec et faucibus nisl, quis dapibus urna. Nulla gravida ornare lectus a varius. Cras dignissim nec ante et ullamcorper. Proin varius sem ac lectus dictum egestas. Suspendisse semper tortor eu ante aliquet, sed lacinia risus dignissim. Aenean sagittis finibus elit accumsan vestibulum. Phasellus fermentum porta arcu eu ultricies.\n\n Praesent efficitur sollicitudin posuere. Curabitur sit amet luctus massa. Donec viverra nisi congue purus vestibulum, vel rhoncus eros lobortis. Mauris pellentesque aliquam nunc, mollis rutrum tellus consectetur in. Curabitur rutrum rutrum ex et blandit. Pellentesque odio enim, placerat vitae congue eget, volutpat lobortis nisi. Donec massa orci, euismod ut suscipit nec, cursus sed quam. Suspendisse iaculis lorem id nisi aliquam, sit amet maximus est tristique.\n\n Curabitur ut orci nisi. Praesent lectus lectus, maximus sed metus at, lobortis efficitur velit. In a nunc id magna accumsan ullamcorper vitae scelerisque nisi. Duis sollicitudin massa sed pharetra vehicula. Aenean metus justo, rutrum vel tincidunt tempor, viverra nec purus. Etiam et pharetra mauris. Donec sodales gravida tortor, in tristique felis finibus ut. Nunc egestas sapien nec turpis sollicitudin, ut tristique magna accumsan. Integer posuere gravida diam. Curabitur ut sodales sapien.',
							}),
							FlexLayoutRow(
								{
									blockClass: 'institutional-video',
									horizontalAlign: 'left',
									fullWidth: true,
									mzTitle: 'EG | Vídeo',
								},
								[
									Video({
										blockClass: 'institutional-video',
										src: 'https://www.youtube.com/watch?v=8-KpLN57wOc',
										height: '509px',
										width: '770px',
									}),
								],
							),
							RichText({
								mzTitle: 'EG | Conteúdo 3',
								blockClass: 'body__inst-group-6',
								text: '## Título institucional EG | H1 \n Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla consequat ac turpis nec congue. Ut efficitur blandit tempus. Mauris quis tellus facilisis, faucibus dui a, condimentum tortor. Nunc dignissim, augue nec ultrices pulvinar, nunc turpis vulputate ipsum, id convallis dolor mi a eros. In maximus ligula eget nisl dignissim, id sagittis metus accumsan. Fusce sed ex a nisi vehicula dignissim. Donec et faucibus nisl, quis dapibus urna. Nulla gravida ornare lectus a varius. Cras dignissim nec ante et ullamcorper. Proin varius sem ac lectus dictum egestas. Suspendisse semper tortor eu ante aliquet, sed lacinia risus dignissim. Aenean sagittis finibus elit accumsan vestibulum. Phasellus fermentum porta arcu eu ultricies.\n\n Praesent efficitur sollicitudin posuere. Curabitur sit amet luctus massa. Donec viverra nisi congue purus vestibulum, vel rhoncus eros lobortis. Mauris pellentesque aliquam nunc, mollis rutrum tellus consectetur in. Curabitur rutrum rutrum ex et blandit. Pellentesque odio enim, placerat vitae congue eget, volutpat lobortis nisi. Donec massa orci, euismod ut suscipit nec, cursus sed quam. Suspendisse iaculis lorem id nisi aliquam, sit amet maximus est tristique.\n\n Curabitur ut orci nisi. Praesent lectus lectus, maximus sed metus at, lobortis efficitur velit. In a nunc id magna accumsan ullamcorper vitae scelerisque nisi. Duis sollicitudin massa sed pharetra vehicula. Aenean metus justo, rutrum vel tincidunt tempor, viverra nec purus. Etiam et pharetra mauris. Donec sodales gravida tortor, in tristique felis finibus ut. Nunc egestas sapien nec turpis sollicitudin, ut tristique magna accumsan. Integer posuere gravida diam. Curabitur ut sodales sapien.',
							}),
						],
					),
				],
			),
		],
	};
};

const images = [
	{
		image: 'https://via.placeholder.com/1920x400',
		description: 'Imagem',
	},
	{
		image: 'https://via.placeholder.com/1920x400',
		description: 'Imagem',
	},
	{
		image: 'https://via.placeholder.com/1920x400',
		description: 'Imagem',
	},
];

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--brand-color-primary-pure', to: '--inst-group-6-menu-mobile-color', name: 'Menu Title Mobile' },
			{ from: '--text-color-1', to: '--inst-group-6-menu-desktop-color', name: 'Menu Title Desktop' },
			{ from: '--text-color-1', to: '--inst-group-6-menu-item-color', name: 'Menu Item' },
			{ from: '--brand-color-primary-pure', to: '--inst-group-6-link-color', name: 'Link' },
			{ from: '--text-color-1', to: '--inst-group-6-text-color', name: 'Content' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xl', to: '--inst-group-6-menu-header-d-fs', name: 'Menu Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-6-menu-header-m-fs', name: 'Menu Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-6-menu-item-fs', name: 'Menu Item' },
			{ from: '--font-size-xl', to: '--inst-group-6-content-header-d-fs', name: 'Content Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-6-content-header-m-fs', name: 'Content Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-6-content-fs', name: 'Content' },
			{ from: '--font-size-xs', to: '--inst-group-6-cwi-fs', name: 'Content With Icon' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--inst-group-6-menu-header-ff', name: 'Menu Header' },
			{ from: '--main-font', to: '--inst-group-6-menu-item-ff', name: 'Menu' },
			{ from: '--main-font', to: '--inst-group-6-content-header-ff', name: 'Content Header' },
			{ from: '--main-font', to: '--inst-group-6-content-ff', name: 'Content' },
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-nano', to: '--inst-group-6-menu-gap', name: 'Menu Item Gap' }],
	},
];
export default InstitutionalGroup;
